import React, { MouseEvent, useState } from "react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { WidgetTypeType } from "@intelligems/ig-types";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, MenuItem } from "@mui/material";

import { mpClickEditWidgetButton } from "../../utils/mixpanel";

export interface MoreMenuWidgetProps {
  widgetType: WidgetTypeType;
  toggleDrawer: () => void;
}

export const MoreMenuWidget = ({
  toggleDrawer,
  widgetType,
}: MoreMenuWidgetProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onEditClick = () => {
    mpClickEditWidgetButton(widgetType);
    toggleDrawer();
    handleClose();
  };

  return (
    <>
      <IgButton
        color={"primary"}
        variant={"text"}
        id="more-button"
        aria-controls="more-positioned-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IgButton>
      <Menu
        id="more-positioned-menu"
        aria-labelledby="more-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={onEditClick}>
          <IgTypography>Edit</IgTypography>
        </MenuItem>
      </Menu>
    </>
  );
};
